import SliderAbstract from './SliderAbstract';

const $ = jQuery;

export default class SliderGeneral extends SliderAbstract {
    constructor(selector) {
        super(selector);
    }

    _init() {
        this._initSlider();
    }

    _initSlider() {
        $(this.selector).each((index, element)=>{
            this.originalSettings.prevButton = $(element).siblings('.swiper__button--prev');
            this.originalSettings.nextButton = $(element).siblings('.swiper__button--next');
            let settings = Object.assign({}, this.originalSettings);

            //iphone specific settings
            if ($(element).hasClass('swiper__container--iphone')) {
                settings.autoplay = '4000';
            }

            new Swiper (element, settings);
        });
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/SliderGeneral.js